<div class="inline-flex items-center gap-x-1.5 rounded-md bg-neutral-a4 px-1.5 py-0.5 text-sm font-medium">
  <div
    class="size-1.5 rounded-full"
    [class.bg-green-9]="status() === sendStatus.SENT"
    [class.bg-amber-9]="status() === sendStatus.PENDING"
    [class.bg-red-9]="status() === sendStatus.CANCELED"
  ></div>
  {{ status() | sendStatusDisplay }}
</div>
